var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevel5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 26,
    viewBox: "0 0 77 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 26,
    rx: 3,
    fill: "#FF4D4D",
    fillOpacity: 0.2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 18,
    fill: "#FF4D4D",
    fontFamily: "Arial",
    fontSize: 14
  }, "Level :5")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel5);
export default __webpack_public_path__ + "static/media/level5.7e8cba7c28097c6e0f4bcfcfc2ea4afa.svg";
export { ForwardRef as ReactComponent };